import React, { useEffect, useState, useRef } from "react";
import {
  TextField,
  InputAdornment,
  Button,
  FormHelperText,
  Snackbar,
  Alert,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import {
  validateMobileOTPAPICall,
  reSendMobileOTPAPICall,
  SaveIpAddressAPICall,
} from "../shared/APICalls";
import {
  IMobileOtpValidation,
  IReSendMobileOTP,
  ISaveIPaddress,
} from "../shared/dtos";
import routesData from "../shared/routes.json";
import ConfitmOtpStyles from "../pages/Styles/ConfitmOtpStyles.module.scss";
import SnackBar from "../Components/SnackBars/SnackBar";
import Slide, { SlideProps } from "@mui/material/Slide";
import firstockLogo from "../Components/assets/Images/Firstocklogo.svg";
import otpIcon from "../Components/assets/Images/otpIcon.svg";
import axios from "axios";
import TagManager from "react-gtm-module";
type TransitionProps = Omit<SlideProps, "direction">;

function TransitionUp(props: TransitionProps) {
  return <Slide {...props} direction="down" />;
}

const dots = ["1", "2", "3", "4", "5", "6"];

export default function ConfirmOtpPage() {
  const navigate = useNavigate();
  const mobile: any = sessionStorage.getItem("mobile");
  const latitude: any = sessionStorage.getItem("latitude");
  const longitude: any = sessionStorage.getItem("longitude");
  const [otp, setOTP] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [countdown, setCountdown] = useState<any>(30);
  const [timerId, setTimerId] = useState<any>(null);
  const [open, setOpen] = useState(false);
  const [wrongOTP, setWrongOTP] = useState(false);
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState("");
  const [IPAddress, setIPAddress] = useState("");
  const [transition, setTransition] = React.useState<
    React.ComponentType<TransitionProps> | undefined
  >(undefined);

  const navigationData = routesData;

  useEffect(() => {
    window.scrollTo(0, 0);
    if (mobile === null) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    setIsButtonDisabled(true);
    setCountdown(30);

    if (timerId === null) {
      let interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
      setTimerId(interval);
    }
  }, []);
  useEffect(() => {
    if (countdown <= 0 && timerId !== null) {
      setIsButtonDisabled(false);

      clearInterval(timerId);
      setTimerId(null);
    }
  }, [countdown]);

  function validateMobileOTP(data: any) {
    setloading(true);

    TagManager.dataLayer({
      dataLayer: {
        event: "formSubmitMobileotp",
        phone: data,
      },
    });

    const source = sessionStorage.getItem("source");
    const id = sessionStorage.getItem("id");

    let obj: IMobileOtpValidation = {
      mobile: mobile,
      mobile_otp: data,
      ref_source: source ? source : "web",
      ref_code: id ? id : "",
    };
    setTimeout(() => {
      validateMobileOTPAPICall(obj)
        .then((response: any) => {
          const responseData = response.data;
          // console.log("response", responseData);
          if (responseData.data.next_stage === "application_approved") {
            if (responseData.data.access_token) {
              // console.log("token", responseData.data.access_token);
              sessionStorage.setItem(
                "access-token",
                responseData.data.access_token
              );
            }

            if (responseData.data.client_code) {
              sessionStorage.setItem(
                "client_id",
                responseData.data.client_code
              );
            }
            navigate(navigationData[responseData.data.next_stage]);
          } else {
            if (responseData.data.access_token) {
              // console.log("token", responseData.data.access_token);
              sessionStorage.setItem(
                "access-token",
                responseData.data.access_token
              );
            }

            if (responseData.data.client_code) {
              sessionStorage.setItem(
                "client_id",
                responseData.data.client_code
              );
            }
            sessionStorage.removeItem("source");
            sessionStorage.removeItem("id");
            setloading(false);
            // setMessage(responseData.data.message);
            setWrongOTP(false);
            let objIPAddress: ISaveIPaddress = {
              latitude: latitude,
              longitude: longitude,
            };
            SaveIpAddressAPICall(objIPAddress)
              .then((response: any) => {
                // console.log("responseIPSave", response.data);
                if (
                  responseData.data.next_stage &&
                  navigationData.hasOwnProperty(responseData.data.next_stage)
                ) {
                  navigate(navigationData[responseData.data.next_stage]);
                }
              })
              .catch((error: any) => {
                if (error.response.data.message) {
                  setMessage(
                    error.message.includes("Network")
                      ? "Error occured, Please try again"
                      : error.response.data.message
                  );
                } else {
                  setMessage("Error occured, Please try again");
                }
                setloading(false);
                setTimeout(() => {
                  setMessage("");
                }, 5000);
              });
          }
        })
        .catch((error: any) => {
          // console.log(error.response.status);
          setWrongOTP(true);
          setloading(false);
          if (error.response.status === 404) {
            setMessage("Failed to Continue, Please try Again");
            setTimeout(() => {
              setMessage("");
            }, 5000);
          }
          setMessage(
            error.message.includes("Network")
              ? "Error occured, Please try again"
              : error.response.data.message
          );
          setTimeout(() => {
            setMessage("");
          }, 5000);
        });
    }, 500);
  }

  function reSendMobileOTP() {
    let obj: IReSendMobileOTP = {
      mobile: mobile,
    };
    reSendMobileOTPAPICall(obj)
      .then((response: any) => {
        const responseData = response.data.data;
        setloading(false);
        setTransition(() => TransitionUp);
        setOpen(true);
        setTimeout(() => {
          setOpen(false);
        }, 3000);
        setIsButtonDisabled(true);
        setCountdown(30);
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          setMessage("Failed to Continue, Please try Again");
          setTimeout(() => {
            setMessage("");
          }, 5000);
        }
        setMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.message
        );
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });

    if (timerId === null) {
      let interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
      setTimerId(interval);
    }
  }
  const handleResendOTP = () => {
    setloading(true);
    reSendMobileOTP();
  };
  const handleBackClick = () => {
    navigate("/");
  };

  function validateOTP(value: any) {
    let error: any;
    if (!value) {
      error = "OTP Required";
    } else if (!/^[0-9]{6}$/.test(value)) {
      error = "Must be a valid 6 digit OTP";
    }
    return error;
  }

  const handleChangeField = (
    name: any,
    value: any,
    setFieldValue: any,
    values: any
  ) => {
    setFieldValue(name, value);
    // console.log(value);
    if (value.length === 6) {
      validateMobileOTP(value);
    }
  };

  return (
    <>
      <div className={ConfitmOtpStyles.wrapper}>
        <div className={ConfitmOtpStyles.RightContainer}>
          <div className={ConfitmOtpStyles.topLogoSection}>
            <img src={firstockLogo} className={ConfitmOtpStyles.topLogo} />
          </div>

          <div className={ConfitmOtpStyles.contentSection}>
            <div className={ConfitmOtpStyles.headerSection}>
              <p className={ConfitmOtpStyles.signup}>OTP Authentication</p>
              <p className={ConfitmOtpStyles.subText}>
                6 Digit code sent to your Mobile <span>+91&nbsp;{mobile}</span>
                <a
                  onClick={handleBackClick}
                  className={ConfitmOtpStyles.change}
                >
                  (Change)
                </a>
              </p>
            </div>
            <Formik
              initialValues={{
                mobileotp: "",
              }}
              onSubmit={(values) => {
                // console.log(values);
                setloading(true);

                validateMobileOTP(values.mobileotp);
              }}
            >
              {({
                errors,
                touched,
                handleChange,
                values,
                handleSubmit,
                setFieldValue,
              }) => (
                <Form
                  onKeyDown={(event) => {
                    // event.code === "Enter" ||
                    //   (event.code === "NumpadEnter" && handleSubmit());
                    event.code === "Enter" && handleSubmit();
                  }}
                  style={{ width: "100%" }}
                >
                  <div style={{ width: "100%", position: "relative" }}>
                    <Field
                      name="mobileotp"
                      validate={validateOTP}
                      render={({ field }) => (
                        <TextField
                          autoComplete="off"
                          autoFocus
                          {...field}
                          sx={{
                            fieldset: {
                              borderColor: "#E5E7EB",
                              borderRadius: "100px",
                              height: "60px",
                            },
                            background: "transparent",
                          }}
                          label=""
                          InputLabelProps={{ shrink: false }}
                          placeholder=""
                          // placeholder="••••••"
                          type="numeric"
                          className={ConfitmOtpStyles.textfield}
                          variant="outlined"
                          value={values.mobileotp}
                          onChange={(event) => {
                            const updatedValue = event.target.value;
                            handleChangeField(
                              "mobileotp",
                              updatedValue,
                              setFieldValue,
                              values
                            );
                          }}
                          inputProps={{
                            sx: {
                              "&::placeholder": {
                                paddingLeft: "-20px",

                                fill: "var(--Black-Black-500, #6B7280)",
                                fontWeight: 600,
                                fontSize: "2.19rem",
                                background: "transparent",
                                height: "29px",
                                letterSpacing: { xs: "23px", sm: "19px" },
                              },
                              // borderLeft: "1px solid #E5E7EB",
                              // height: "30px",
                              paddingLeft: "-20px",

                              fontWeight: 500,
                              letterSpacing: { xs: "29.5px", sm: "24.5px" },

                              background: "transparent",
                            },
                            maxLength: 6,
                            inputMode: "numeric",
                            pattern: "[0-9]*",
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment
                                position="start"
                                style={{
                                  // borderRight: "1px solid #E5E7EB",
                                  // height: "22px",
                                  paddingRight: "10px",
                                  paddingLeft: "5px",
                                }}
                              >
                                <img src={otpIcon} />
                              </InputAdornment>
                            ),
                          }}
                          onKeyPress={(event) => {
                            const keyCode = event.keyCode || event.which;
                            const keyValue = String.fromCharCode(keyCode);
                            const isValidKey = /^\d+$/.test(keyValue);

                            if (!isValidKey) {
                              event.preventDefault();
                            }
                          }}
                        />
                      )}
                    />
                    <FormHelperText
                      style={{
                        color: "#d32f2f",
                        height: "10px",
                        marginTop: "3px",
                        textAlign: "center",
                      }}
                    >
                      {touched.mobileotp && errors.mobileotp?.toString()}
                    </FormHelperText>

                    {values.mobileotp.length === 0 && (
                      <div className={ConfitmOtpStyles.placeholderstyling}>
                        {dots.map((a: any, index: any) => (
                          <div
                            className={ConfitmOtpStyles.dot}
                            style={{
                              opacity:
                                values.mobileotp.length + 1 >= index + 1
                                  ? "0.4"
                                  : "1",
                            }}
                          ></div>
                        ))}
                      </div>
                    )}
                    {values.mobileotp.length > 0 && (
                      <div className={ConfitmOtpStyles.placeholderstyling}>
                        {dots.map((a: any, index: any) => (
                          <div
                            className={ConfitmOtpStyles.dot}
                            style={{
                              opacity:
                                values.mobileotp.length + 1 >= index + 1
                                  ? "0.4"
                                  : "1",
                              visibility:
                                values.mobileotp.length >= index + 1
                                  ? "hidden"
                                  : "visible",
                            }}
                          ></div>
                        ))}
                      </div>
                    )}
                  </div>

                  <SnackBar message={message} />

                  {isButtonDisabled ? (
                    <div className={ConfitmOtpStyles.resendSection}>
                      <p className={ConfitmOtpStyles.clickhere}>
                        Resend OTP in{" "}
                        <span style={{ color: "#3263E5" }}>{countdown}</span>{" "}
                        Seconds
                      </p>
                    </div>
                  ) : (
                    <div className={ConfitmOtpStyles.resendSection}>
                      <LoadingButton
                        onClick={() => {
                          setFieldValue("mobileotp", "");
                          handleResendOTP();
                        }}
                        disableFocusRipple
                        disableTouchRipple
                        disableElevation
                        focusRipple={false}
                        //loading={loading}
                        variant="text"
                        id="confirmMobileOtpResendOtpButton"
                        sx={{
                          marginTop: "10px",
                          color: "#3263E5",
                          height: "max-content",
                          padding: "5px 20px",
                        }}
                      >
                        Resend OTP
                      </LoadingButton>
                    </div>
                  )}

                  <div className={ConfitmOtpStyles.buttonSection}>
                    {values.mobileotp.length === 6 ? (
                      <LoadingButton
                        variant="contained"
                        type="submit"
                        loading={loading}
                        id="confirmMobileOtpContinueButton"
                        className={ConfitmOtpStyles.button}
                        onClick={() => {
                          handleSubmit();
                        }}
                      >
                        Continue
                      </LoadingButton>
                    ) : (
                      <Button
                        variant="contained"
                        disabled
                        id="confirmMobileOtpContinueDisabledButton"
                        className={ConfitmOtpStyles.button}
                      >
                        Continue
                      </Button>
                    )}
                  </div>

                  <Snackbar
                    open={open}
                    autoHideDuration={3000}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    TransitionComponent={transition}
                    sx={{ marginTop: "50px" }}
                  >
                    <div
                      style={{ background: "#54BF00", borderRadius: "10px " }}
                    >
                      <div style={{ marginLeft: "30px" }}>
                        <Alert
                          icon={false}
                          severity="success"
                          sx={{
                            width: "max-content",
                            height: "50px",
                            fontSize: "16px",
                            borderRadius: "0",
                          }}
                        >
                          Successfully sent the OTP to your Mobile.
                        </Alert>
                      </div>
                    </div>
                  </Snackbar>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
}
